import { Route, Switch, useRouteMatch } from 'react-router-dom'
import { PaymentsCard } from './PaymentsCard'
import { PaymentsList } from './PaymentsList'

export const Payments = () => {
  const match = useRouteMatch()

  return (
    <Switch>
      <Route path={`${match.url}/show/:paramTabIndex/:id`} exact>
        <PaymentsCard />
      </Route>
      <Route path={`${match.url}/:params?`}>
        <PaymentsList />
      </Route>
    </Switch>
  )
}
